// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f5YU1","buttons":"styles_buttons__2WsZV"};